module.exports = __webpack_public_path__ + "static/img/naniungo-slide-4.00054839.jpg";